import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import EditEmailTemplatesPage from "PFModules/admin/email_templates/edit/edit_email_templates_page";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useEditEmailTemplatePage } from "./use_edit_email_template_page";

const initPage = { emailTemplate: null, emailTemplateSchemas: null, loaded: false };

const EditEmailTemplateController = () => {
  const { t } = useTranslation("admin", { keyPrefix: "emailTemplates" });
  const { id } = useParams();
  const { loaded, emailTemplate, emailTemplateSchemas, errors } = useEditEmailTemplatePage(initPage, { id });
  const WrappedEditEmailTemplaPage = usePageWrapper(EditEmailTemplatesPage);

  return (
    <WrappedEditEmailTemplaPage
      loading={!loaded}
      errors={errors}
      errorComponent={
        <NotFoundComponent
          message={t("pageLoadingErrorMessage")}
          buttonMessage={t("pageLoadingErrorButtonLabel")}
          buttonUrl="/admin/email_templates"
        />
      }
      emailTemplate={emailTemplate}
      emailTemplateSchemas={emailTemplateSchemas}
      id={id}
    />
  );
};

export default EditEmailTemplateController;
